export const NonAffiliationDisclaimer = () => {
  return (
    <div className="flex flex-col py-6 items-center justify-evenly text-center">
      <p>Non-Affiliation Disclaimer</p>
      <p className="text-xs">
        The Miles Market site is not endorsed by, or directly affiliated with
        any hotel or airline.
      </p>
    </div>
  );
};
